<label>
  <span class="label">{{ label }}{{ required ? '*' : '' }}</span>
  <textarea
    (blur)="onBlur()"
    [(ngModel)]="innerValue"
    [name]="name"
    [required]="required"
    [pattern]="pattern"
    [rows]="rows"
    [placeholder]="placeholder"
  >
  </textarea>

  <span
    class="form-error-message"
    *ngIf="required && touched && !innerValue?.trim() && !suppressErrors"
    >{{ label }} is required</span
  >
</label>
